import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHubspotCreditsData } from '../components/Accounts/AccountsExtrasLinks/HubspotCreditsLink/api';
export const initialState = {
  isLoading: true,
  totalCredits: 0,
  creditsUsed: 0,
  hasError: false
};
export const fetchCreditsData = createAsyncThunk('credits/fetchCreditsData', () => getHubspotCreditsData());
export const creditsSlice = createSlice({
  name: 'credits',
  initialState,
  reducers: {
    setCreditsData: (state, action) => {
      state.totalCredits = action.payload.totalCredits;
      state.creditsUsed = action.payload.creditsUsed;
    }
  },
  extraReducers(builder) {
    builder.addCase(fetchCreditsData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.totalCredits = action.payload.totalCredits;
      state.creditsUsed = action.payload.creditsUsed;
      state.hasError = false;
    }).addCase(fetchCreditsData.rejected, state => {
      state.isLoading = false;
      state.hasError = true;
    });
  }
});
export const {
  setCreditsData
} = creditsSlice.actions;
export default creditsSlice.reducer;